import React from 'react';
import { observer } from 'mobx-react';

import { Button, Icon } from 'semantic-ui-react';

import '../css/StudentAssignmentTryAgainButton.less';

import { SatCoreRegister } from '../SatCoreRegistry';

import { CONTENT_MODE } from '../managers/ContentManager';
import studentAssignmentPlayerLauncherManager from '../managers/StudentAssignmentPlayerLauncherManager';

import StudentAssignmentPlayerLauncherService from '../services/StudentAssignmentPlayerLauncherService';

const StudentAssignmentTryAgainButton = observer((props) => {
  const { assignment, onSelfPacedOpen, t } = props;

  if (!assignment) {
    return null;
  }

  const handleClick = () => {
    if (typeof onSelfPacedOpen === 'function') {
      onSelfPacedOpen(CONTENT_MODE.ASSESS, assignment);
      return;
    }
    StudentAssignmentPlayerLauncherService.launchTryAgainStudentPacedAttempt({
      assignment,
      contentMode: CONTENT_MODE.ASSESS
    });
  };

  return (
    <Button
      className='StudentAssignmentTryAgainButton'
      disabled={studentAssignmentPlayerLauncherManager.isLaunchingAssignment}
      onClick={handleClick}>
      <Icon name='redo alternate' />
      {t('tryAgain')}
    </Button>
  );
});

export default StudentAssignmentTryAgainButton;

SatCoreRegister('StudentAssignmentTryAgainButton', StudentAssignmentTryAgainButton);
